const generalities = require.context(".", true, /general_.*\.js$/);
generalities.keys().forEach(generalities);
